<div class="page-container">
  <div class="profile-card">
    <h1>Delete Profile</h1>

    <p class="subtitle">
      Please provide your details to finish setting up your account.
    </p>

    <form [formGroup]="moduleForm" (ngSubmit)="onSubmit()">

      <div class="form-grid">
        <div class="form-group">
          <label for="fullName">FULL NAME</label>
          <input type="text" id="fullName" formControlName="fullName" placeholder="eg. John Doe">
          <p *ngIf="showError('fullName')" class="error">
            <span *ngIf="f.fullName.errors?.required">
              Required
            </span>
          </p>
        </div>

        <div class="form-group">
          <label>DATE OF BIRTH</label>

          <div class="input-group">
            <input class="form-control" [ngClass]="{'is-invalid': showError('dob')}" formControlName="dob" ngbDatepicker
              #dobPicker="ngbDatepicker" [maxDate]="maxDate" [container]="'body'" />

            <button class="btn btn-outline-secondary" type="button" (click)="dobPicker.toggle()">
              <fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
            </button>
          </div>

          <p *ngIf="showError('dob')" class="error">
            <span *ngIf="f.dob.errors?.required">
              Required
            </span>
          </p>
        </div>
        <!-- <div class="input-group">
          <label>DATE OF BIRTH</label>

          <input class="form-control" [ngClass]="{'is-invalid':showError('start_date')}" placeholder=""
            formControlName="start_date" ngbDatepicker id="start_date" #start_date="ngbDatepicker"
            [minDate]="minStartDate" [container]="'body'" />
          <button class="btn btn-outline-secondary" (click)="start_date.toggle()" type="button">
            <fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
          </button>
          <p *ngIf="showError('dob')" class="error">
            <span *ngIf="f.dob.errors?.required">
              Required
            </span>
          </p>
        </div> -->

        <div class="form-group">
          <label>IMO NUMBER</label>
          <input type="text" id="imoNumber" formControlName="imoNumber" placeholder="1234567">
          <p *ngIf="showError('imoNumber')" class="error">
            <span *ngIf="f.imoNumber.errors?.required">
              Required
            </span>
          </p>
        </div>

        <div class="form-group">
          <label>PASSPORT NUMBER</label>
          <input type="text" id="passportNumber" formControlName="passportNumber" placeholder="A12345678">
          <p *ngIf="showError('passportNumber')" class="error">
            <span *ngIf="f.passportNumber.errors?.required">
              Required
            </span>
          </p>
        </div>

        <div class="form-group">
          <label>COUNTRY CODE</label>
          <ng-select [ngClass]="{'is-invalid': showError('countryCode')}" [items]="countryCodes" bindLabel="display"
            bindValue="dial_code" [clearable]="true" [multiple]="false" id="countryCode" formControlName="countryCode"
            appendTo="body">
          </ng-select>
          <p *ngIf="showError('countryCode')" class="error">
            <span *ngIf="f.countryCode.errors?.required">
              Required
            </span>
          </p>
        </div>

        <div class="form-group">
          <label>MOBILE NUMBER</label>
          <input type="text" id="mobileNumber" formControlName="mobileNumber" placeholder="eg. 9876543210">
          <p *ngIf="showError('mobileNumber')" class="error">
            <span *ngIf="f.mobileNumber.errors?.required">
              Required
            </span>
            <span *ngIf="f.mobileNumber.errors?.pattern">
              Invalid Mobile Number
            </span>
          </p>
        </div>
      </div>

      <div class="button-wrapper">
        <button *ngIf="!showLoader" type="submit" class="submit-btn">
          Continue
        </button>
        <div *ngIf="showLoader" class="loader-container" role="status" aria-label="Loading">
          <div class="circular-loader"></div>
        </div>
      </div>

    </form>
  </div>

  <!-- Confirmation Popup Overlay -->
  <div class="modal-overlay" *ngIf="showConfirmPopup" (click)="closeConfirm()">
    <div class="modal-card confirm-card" (click)="$event.stopPropagation()">
      <div class="modal-icon warning-icon">
        <fa-icon [icon]="['fas', 'exclamation-triangle']"></fa-icon>
      </div>
      <h2>Delete You Account?</h2>
      <p>Are you sure you want to delete your account ?</p>
      <div class="modal-buttons">
        <button type="button" class="modal-btn btn-secondary" (click)="closeConfirm()">Cancel</button>
        <button type="button" class="modal-btn btn-primary" (click)="confirmSave()">Confirm</button>
      </div>
    </div>
  </div>

  <!-- Success Done Popup Overlay -->
  <div class="modal-overlay" *ngIf="showDonePopup">
    <div class="modal-card done-card">
      <div class="modal-icon success-icon">
        <fa-icon [icon]="['fas', 'check']"></fa-icon>
      </div>
      <h2>Done!</h2>
      <p>Your account has been successfully deleted. We’re sorry to see you go! You will now be redirected to our home
        page.</p>
      <p class="redirect-msg">Redirecting in 5 seconds...</p>
      <div class="spinner-container">
        <div class="spinner-bar"></div>
      </div>
    </div>
  </div>
</div>